import type { SubscriptionPlan } from '../components/subscription/SubscriptionSelector';
import { subscriptionLimits } from './subscriptionLimits';

const { starter, business, professional } = subscriptionLimits;

export const foundingOfferText = {
  monthly: 'Founding customer offer: 50% off for 6 paid months.',
  yearly: 'Founding customer offer: 50% off your first annual invoice.',
};

export const billingNote = {
  monthly:
    '45 days free, then {discountedPrice}/month for 6 months, then {regularPrice}/month.',
  yearly:
    '45 days free, then {discountedPrice} for your first year (50% off), then {regularPrice}/year. Billed annually upfront.',
};

export const plans: [SubscriptionPlan, SubscriptionPlan, SubscriptionPlan] = [
  {
    id: 'starter',
    name: 'Starter',
    description: 'Perfect for small operations just getting started',
    price: starter.price,
    features: [
      { label: `Up to ${starter.users} users` },
      { label: `Up to ${starter.pools} pools` },
      {
        label: `Up to ${starter.services} services and ${starter.repairs} repairs per month`,
      },
      { label: 'Basic reporting and analytics' },
      {
        label: `Up to ${starter.photos.perService} photos per service`,
      },
      {
        label: `Up to ${starter.photos.perRepair} photo per repair`,
      },
      { label: 'Priority support', included: false },
    ],
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'For growing teams managing a larger pool portfolio',
    badgeLabel: 'Most popular',
    price: professional.price,
    features: [
      { label: `Up to ${professional.users} users` },
      { label: `Up to ${professional.pools} pools` },
      {
        label: `Up to ${professional.services} services and ${professional.repairs} repairs per month`,
      },
      { label: 'Advanced reporting and analytics' },
      {
        label: `Up to ${professional.photos.perService} photos per service`,
      },
      {
        label: `Up to ${professional.photos.perRepair} photos per repair`,
      },
      { label: 'Priority support' },
    ],
  },
  {
    id: 'business',
    name: 'Business',
    description: 'Enterprise-scale operations with unlimited capacity',
    price: business.price,
    features: [
      { label: `Up to ${business.users} users` },
      { label: `Unlimited pools` },
      {
        label: 'Unlimited pool services and repairs per month',
      },
      { label: 'Advanced reporting and analytics' },
      {
        label: `Up to ${business.photos.perService} photos per service`,
      },
      {
        label: `Up to ${business.photos.perRepair} photos per repair`,
      },
      { label: 'Priority support' },
    ],
  },
];
